(() => {
  const initFollowCheck = root => {
    const q = selector => root.querySelector(selector);
    const dialog = q('[data-follow-check]');
    const links = q('[data-follow-links]');
    if (!dialog || !links || !q('[data-follow-art]')) return {enable() {}, hide() {}};
    const more = q('.amuru-more');
    const art = JSON.parse(q('[data-follow-art]').textContent);
    const face = q('[data-follow-face]');
    const title = q('[data-follow-title]');
    const copy = q('[data-follow-copy]');
    const answers = q('[data-follow-answers]');
    const retry = q('[data-follow-retry]');
    const next = q('[data-follow-continue]');
    let seen = false, prompted = false, confirmed = false, warmed = false;
    let previousY = window.scrollY, pendingFrame = false, returnFocus;
    const close = () => { if (dialog.open) dialog.close(); };
    const complete = () => {
      // This is the visitor's own answer, not a verified subscription status.
      confirmed = true;
      dialog.dataset.result = 'yes';
      face.src = art.success;
      face.alt = '任務完了と敬礼する花冠あむる';
      title.textContent = 'よし！任務完了！';
      copy.textContent = 'これであなたも今日から花冠組！\nまた配信で会おうね♡';
      answers.hidden = true; retry.hidden = true; next.hidden = false;
      next.focus({preventScroll:true});
    };
    const ask = () => {
      if (prompted || confirmed || more.hidden || !root.isConnected) return;
      prompted = true;
      returnFocus = document.activeElement;
      face.src = art.wait[Math.floor(Math.random() * art.wait.length)];
      dialog.showModal();
    };
    const observer = new IntersectionObserver(entries => {
      if (!more.hidden && entries.some(entry => entry.isIntersecting)) seen = true;
    });
    observer.observe(links);
    window.addEventListener('scroll', () => {
      if (pendingFrame) return;
      pendingFrame = true;
      requestAnimationFrame(() => {
        pendingFrame = false;
        const currentY = window.scrollY;
        const downward = currentY > previousY;
        previousY = currentY;
        // Ask once, only after the revealed channel buttons have been passed.
        if (!more.hidden && seen && downward && !prompted && !confirmed &&
            links.getBoundingClientRect().bottom < Math.min(160, window.innerHeight * .25)) ask();
      });
    }, {passive:true});
    q('[data-follow-yes]').addEventListener('click', complete);
    q('[data-follow-done]').addEventListener('click', complete);
    q('[data-follow-no]').addEventListener('click', () => {
      dialog.dataset.result = 'no';
      face.src = art.cry;
      face.alt = 'ふええと涙を流す花冠あむる';
      title.textContent = 'ふええ…涙';
      copy.textContent = 'まだだったのぉ…？\nここから登録してくれたら、うれしいな♡';
      answers.hidden = true; retry.hidden = false; next.hidden = true;
      retry.querySelector('a').focus({preventScroll:true});
    });
    q('[data-follow-close]').addEventListener('click', close);
    next.addEventListener('click', close);
    dialog.addEventListener('close', () => {
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
    });
    return {
      enable() {
        previousY = window.scrollY;
        if (!warmed) {
          warmed = true;
          [...art.wait, art.cry, art.success].forEach(src => { const image = new Image(); image.src = src; });
        }
      },
      hide: close
    };
  };
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-reactions]').textContent);
    const q = selector => root.querySelector(selector);
    const stage = q('.amuru-stage'), character = q('[data-character]'), butterfly = q('[data-butterfly]');
    const speech = q('[data-speech]'), yes = q('[data-yes]'), no = q('[data-no]'), more = q('.amuru-more');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const followCheck = initFollowCheck(root);
    const shareCopy = q('[data-support-copy]');
    if (shareCopy) shareCopy.addEventListener('click', async () => {
      const text = q('[data-support-text]');
      const status = q('[data-support-status]');
      try {
        await navigator.clipboard.writeText(text.value.trim());
        text.hidden = true;
        status.textContent = 'コピーしたよ♡ ひとこと添えて、あむるを応援してね！';
      } catch {
        text.hidden = false;
        text.focus(); text.select();
        status.textContent = 'この文面をコピーして、あむるを応援してね♡';
      }
    });
    let mode = 'welcome', noIndex = 0, yesIndex = 0, timer, paused = motion.matches, inView = true, version = 0;
    const stop = () => { clearInterval(timer); timer = undefined; };
    const show = (kind, index) => {
      const reaction = data[kind][index % data[kind].length];
      const ticket = ++version;
      const image = new Image();
      image.onload = () => {
        if (ticket !== version) return;
        character.src = reaction.image;
        character.alt = reaction.alt;
        speech.textContent = reaction.text;
        stage.dataset.effect = reaction.effect;
        butterfly.hidden = reaction.effect !== 'butterfly';
        if (!butterfly.hidden && !butterfly.getAttribute('src')) butterfly.src = butterfly.dataset.src;
        stage.classList.remove('amuru-pop');
        requestAnimationFrame(() => stage.classList.add('amuru-pop'));
      };
      image.onerror = () => { if (ticket === version) speech.textContent = reaction.text; };
      image.src = reaction.image;
      const next = data[kind][(index + 1) % data[kind].length];
      const preload = new Image(); preload.src = next.image;
    };
    const restart = () => {
      stop();
      if (mode === 'no' && !paused && inView && !document.hidden) timer = setInterval(() => show('no', noIndex++), 6500);
    };
    no.addEventListener('click', () => {
      mode = 'no'; stage.dataset.mood = 'no';
      more.hidden = true; yes.setAttribute('aria-expanded','false');
      followCheck.hide();
      q('[data-nudge]').textContent = '↓ あむるのおすすめは、断然こっち！ ↓';
      q('[data-yes-label]').textContent = 'あむるのこと、知りたいです♡';
      q('[data-hint]').textContent = 'あむるはYESのお返事を待っています……！';
      show('no', noIndex++); restart();
    });
    yes.addEventListener('click', () => {
      mode = 'yes'; stop(); stage.dataset.mood = 'yes';
      more.hidden = false; yes.setAttribute('aria-expanded','true');
      followCheck.enable();
      q('[data-nudge]').textContent = 'YES、いただきました♡';
      q('[data-yes-label]').textContent = 'もっとあむるに会いたい♡';
      q('[data-hint]').textContent = 'もう一度YESを押すと、別のあむるに会えます。';
      show('yes', yesIndex++);
    });
    document.addEventListener('visibilitychange', restart);
    motion.addEventListener('change', () => { paused = motion.matches; restart(); });
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; restart(); });
    observer.observe(root);
  };
  document.querySelectorAll('[data-amuru-play]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-amuru-play]').forEach(init));
})();
